import { motion, AnimatePresence } from "framer-motion";
import React, { useState, useEffect, useRef } from "react";
import { MdcnCyclSpan } from "../../../views/SelfManagement/BP/Medicine";

const MemoPopup = ({ memoText, mdcnDt, setMemoText, saveMemo, m }) => {
  const [isOpen, setIsOpen] = useState(false);
  const buttonRef = useRef(null);

  const togglePopup = () => {
    setIsOpen(prev => !prev);
  };

  useEffect(() => {
    if (isOpen && buttonRef.current) {
      setTimeout(() => {
        buttonRef.current.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }, 100);
    }
  }, [isOpen]);

  return (
    <div className="infobox">
      {/* 버튼 */}
      <a
        className={`btn-memodown ${isOpen ? "open" : ""}`}
        ref={buttonRef}
        onClick={togglePopup}>
        <u className="per">{m.percent}%</u>
        <div className="day">
          {m.mdcnCyclDtlNm.split(",").map((n, i) => (
            <MdcnCyclSpan
              mdcnCyclDtlNm={n}
              mdcnYn={m.mdcnYn.split(",")[i]}
              key={i}
            />
          ))}
        </div>
      </a>

      {/* 메모 팝업 */}
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.3, ease: "easeInOut" }}
            className="inthe-box memo overflow-hidden">
            <div className="memo-box">
              <textarea
                className="memoTextArea"
                value={memoText}
                onChange={e => setMemoText(e.target.value)}
              />
            </div>

            {/* 저장 버튼 */}
            <div className="save-area">
              <a
                onClick={() => saveMemo(memoText, mdcnDt)}
                className="btn-savecircle">
                <i></i>저장
              </a>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default MemoPopup;
